<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>User - {{this.user}} | Document: {{this.fileTitle}}</h2>
			</b-col>
		</div>
		<div class="card">
	    	<b-row v-if="loadingData">
              	<b-col cols="12" sm="12" md="12" lg="12">
                 	<p class="text-center">
                  		<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                 	</p>
              	</b-col>
            </b-row>
        	<div v-else>
        		<b-row v-if="found">
		      		<b-col cols="12" sm="12" md="12" lg="12" v-if="isImage">
						<img :src="this.file" :alt="this.fileName">
	              	</b-col>
	              	<b-col cols="12" sm="12" md="12" lg="12" v-if="isApplication">
						<embed :src="this.file" width="100%" height="800px">
						<!--object :data="this.file" ></object>
						<iframe :src="this.file" type="application/pdf"></iframe-->
	              	</b-col>
		      	</b-row>
				<b-row v-else>
		      		<b-col cols="12" sm="12" md="12" lg="12">
		      			<br>
	                 	<p class="text-center text-danger">
	                 		<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
	                 	</p>
	              	</b-col>
		      	</b-row>
        	</div>
		</div>
	</div>
</template>
<script>
	import users_service from './users_service'
	export default {
		name:'userDocument',
		props: {
			id: {
				type: String,
				default: 0
			},
			idDocument: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getUserData()
		},
		data () {
			return {
				user: '',
				file: '',
				fileName: '',
				fileTitle: '',
				pdf: '',
				isImage: false,
				isApplication: false,
				loadingData: true,
				found: false,
				notFoundMessage: 'Not found',
				tabIndex: 0
			}
		},
		methods: {
			getTypeDocument ( nameDocument ) {
				var extensionfile = nameDocument.split('.')
				var countExtension = extensionfile.length
				if (extensionfile[countExtension - 1] == "pdf")
					return "application"
				else
					return "image"
			},
			getUserData() {
				users_service.getBy(this.id)
					.then(data => {
						if (data[0] === 'success') {
							var userData = data[1]
							this.user = userData.username
							var filesCount = userData.files.length
							if (filesCount > 0) {
								for(var i = 0; i < filesCount; i++) {
									if (userData.files[i].id == this.idDocument) {
										this.file = userData.files[i].file
										this.fileName = userData.files[i].file_name
										this.fileTitle = userData.files[i].comment
										if (this.getTypeDocument( this.fileName ) == "image")
											this.isImage = true
										else{
											this.pdf = this.file
											console.log(this.file)
											this.isApplication = true
											//window.open(this.file, )
											var childWindow = window.open(this.file, "Drift File", 'width=600,height=300')
											//childWindow.location.reload();
										}
										break
									}
								}
							}
							this.found = true
							this.loadingData = false
						} else {
							this.loadingData = false
							this.notFoundMessage = data[1]
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/users/userDocument.vue